<template>
  <div :class="open ? 'area-cont open' : 'area-cont'" @click="$emit('toggleOpen', index)" >
    <div v-for="(area,i) in areas" :index="i" :key="i">
      <!-- <div :id='index' class="areas" @click='activeIndex = activeIndex === i ? null : i'> -->
      <div :id='area.areaId' class="areas" @click='activeIndex = activeIndex === i ? null : i'>
        {{ area.name }}
        <span class='accordion__arrow'></span>  
      </div>
      <div class="table">
        <div>
            <SeatAvailabilityTable :index="j" :key="j" :seats="area.seats" :displaySlots="displaySlots" />
        </div> 
      </div>
    </div> 
  </div>
</template>

<script>
  import SeatAvailabilityTable from "@/components/SeatAvailabilityTable";

  export default {
    name: 'Accordion',
    //props: ['areas', 'index', 'open'],
    data: () => ({
      activeIndex: null,
    }),

    props: {
      areas: {
        type: Array,
        required: false
      },
      index: {
        type: Number,
        required: false
      },
      open: {
        type: Boolean,
        required: false
      },
      title: {
        type: String,
        required: false
      },
      list: {
        type: Array,
        required: false
      },
      height: {
        type: String,
        required: false
      },
      maxWidth: {
        type: String,
        required: false
      },
      select: {
        type: Object,
        required: false,
        default: function () {
          return {
            show: false,
            selectedItem: null
          }
        }
      },
      fixed: {
        type: Boolean,
        required: false,
      },
      displaySlots: {
        type: Number,
        required: true
      }
    },

    components: {
      SeatAvailabilityTable,
    },

    methods: {
      scrollToAccordion() {
        const id = window.location.pathname.split('/').pop();

        if (!isNaN(parseInt(id))) {
          const element = document.getElementById(id);

          if (element) {
                const parentElement = element.parentElement.parentElement;

                // if (parentElement) {

                // //   console.log('Index: ' + this.index);
                // //   console.log('Id: ' + id);

                //   // Add CSS class to the parent element
                //   //parentElement.classList.add('open'); // Replace 'your-css-class' with the name of your CSS class
                //   //if (this.index === parseInt(id)) {
                //   //  this.open = true;
                //     element.scrollIntoView({ behavior: 'smooth' });
                //   //}
                // }
                    
                  // Scroll the parent element into view
                  //parentElement.scrollIntoView({ behavior: 'smooth' }); 
                
            element.scrollIntoView({ behavior: 'smooth' }); 
          }
        }
      },
    },

    mounted() {
      this.scrollToAccordion();
      setInterval(this.scrollToAccordion, 60000); // load method every 1 min
    },
  };
</script>

<style scoped>
  .area-cont {
    display: block;
    width: 100%;
    margin-top: .5rem;
    border-radius: 8px;
    background-color: #fff;
    cursor: pointer;
  }

  .area-cont .areas {
    padding: 1rem;
    position: relative;
    color: #3c3c3c;
    transition: all 0.4s linear;
    display: flex;
    align-items: center;
  }
  
  .area-cont .areas::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%) rotate(0deg);

    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.25);
  }

  .area-cont.open .areas {
    background-color: #dcdbdb;
  }

  .area-cont.open .areas::after {
    transform: translateY(-50%) rotate(180deg);
  }

  .area-cont .table {
    color: #3c3c3c;
    opacity: 1;
    max-height: 0px;
    padding: 0 1rem;
    overflow-y: hidden;
    transition: max-height 0.5s ease-out;
    transition: padding 0.5s ease-out;
  }

  .area-cont.open .table {
    opacity: 1;
    padding: 2rem 1rem;
    max-height: fit-content;
  }

  .accordion__arrow {
    position: absolute;
    margin-right: 1em;
    width: 1em;
    height: 1em;
    box-sizing: border-box;
    right: 0;
  }
    .accordion__arrow:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: .65em;
      height: .65em;
      border-width: 1px 1px 0 0;
      border-style: solid;
      border-color: initial;
      transform: rotate(45deg) translate(0, -50%);
      transform-origin: top;
      transition: transform .3s ease-out;
      box-sizing: border-box; 
    }

  .area-cont.open > div > .areas > .accordion__arrow:after {
    transform: rotate(135deg) translate(0, -50%); }
</style>
